import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { SubSubGroupDto, SubGroupDto, CategoryDto, SubSubGroupTypeDto, SubSubGroupTypeCategoryDto} from '@cradua/data';
import { NotificationService, ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-subsubgroup-container',
  templateUrl: './subsubgroup-container.component.html',
  styleUrls: ['./subsubgroup-container.component.scss']
})
export class SubSubGroupContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  subsubgrouptypecategorys$: Observable<SubSubGroupTypeCategoryDto[]>;
  subsubgrouptypes$: Observable<SubSubGroupTypeDto[]>;
  categorys$: Observable<CategoryDto[]>;
  subgroups$: Observable<SubGroupDto[]>;
  subsubgroups$: Observable<SubSubGroupDto[]>;
  loading: boolean;
  isLoadingSubSubGroupTypeCategory$: Observable<boolean>;
  isLoadingSubSubGroupType$: Observable<boolean>;
  isLoadingCategory$: Observable<boolean>;
  isLoadingSubGroup$: Observable<boolean>;
  isLoadingSubSubGroup$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoadingSubSubGroupTypeCategory$ = this.gatwayFacade.isLoadingGateway("SubSubGroupTypeCategory"); 
    this.isLoadingSubSubGroupType$ = this.gatwayFacade.isLoadingGateway("SubSubGroupType"); 
    this.isLoadingCategory$ = this.gatwayFacade.isLoadingGateway("Category"); 
    this.isLoadingSubGroup$ = this.gatwayFacade.isLoadingGateway("SubGroup");
    this.isLoadingSubSubGroup$ = this.gatwayFacade.isLoadingGateway("SubSubGroup");

    this.subsubgrouptypecategorys$ = this.gatwayFacade.loadGateway("SubSubGroupTypeCategory");
    this.subsubgrouptypes$ = this.gatwayFacade.loadGateway("SubSubGroupType");
    this.categorys$ = this.gatwayFacade.loadGateway("Category");  
    this.subgroups$ = this.gatwayFacade.loadGateway("SubGroup");
    this.subsubgroups$ = this.gatwayFacade.loadGateway("SubSubGroup");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteSubSubGroup(deletedValue: any) {
    this.gatwayFacade.remove("SubSubGroup", deletedValue);
  }

// this method control both the create and update
  onSubmitSubSubGroup(formValue: any) {
    const pullData = formValue.SubSubGroups;

// declare two empty array to hold update and create data
  const allUpdates = [] ;
  const addAllSubSubGroup = [];

// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id) {
      allUpdates.push(pullData[i]);
    } else {
      addAllSubSubGroup.push(pullData[i]);
    }
  }

// check if the addAllCountry array is not empty, then dispatch the data to the store
   if(addAllSubSubGroup.length > 0) {
    this.gatwayFacade.add('SubSubGroup', addAllSubSubGroup);
   }

// dispatch update data to the store
   if(allUpdates.length > 0) {
    this.gatwayFacade.update('SubSubGroup', allUpdates, ['id']);
   }
  }


}
